<div class="container single-view" id="view-inventory">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/inventories" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'INVENTORIES.BTN_BACK_TO_INVENTORY' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="inventory-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'INVENTORY_SINGLE_VIEW.INVENTORY_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (inventoryData.name) {
                  <span data-testid="inventory-name">
                    {{ inventoryData.name | defaultValue }}
                  </span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='inventory-createdon'class="flex items-center mr-2" pTooltip="{{ 'INVENTORY_SINGLE_VIEW.CREATED_ON' | translate }}"
              tooltipPosition="top"><i class="icon icon-calendar mr-1"></i>{{
              inventoryData.createdOn | date: 'dd-MM-yyyy HH:mm' }}</span>
            <span data-testid='inventory-createdby' class="flex items-center mr-2" pTooltip="{{ 'INVENTORY_SINGLE_VIEW.CREATED_BY' | translate }}"
              tooltipPosition="top"><i class="icon icon-user mr-1"></i>
              @if (inventoryData.createdById && allowViewUser) {
                <a [routerLink]="['/users/', inventoryData.createdById]" class="inline-flex items-center link">
                  {{ inventoryData.createdByFullName | defaultValue }}
                </a>
              } @else {
                {{ inventoryData.createdByFullName | defaultValue }}
              }
            </span>
          </div>

          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3 mt-2">
            @if (allowModifyInventory) {
              <button data-testid="inventory-add-items-btn" [disabled]="inventoryData.isInvalid" class="btn outline-btn inventory-action-btn" (click)="addInventoryItems()">
                {{ 'INVENTORY_SINGLE_VIEW.BTN_ADD_INVENTORY_ITEMS' | translate }}
              </button>

              <button data-testid="inventory-revalidate-items-btn" [disabled]="inventoryData.isInvalid" class="btn outline-btn inventory-action-btn" (click)="revalidateInventoryItems()">
                {{ 'INVENTORY_SINGLE_VIEW.BTN_REVALIDATE_ITEMS' | translate }}
              </button>

              <button data-testid="inventory-edit-btn" [disabled]="inventoryData.isInvalid" class="btn primary-btn inventory-action-btn"
                (click)="goToEditInventory()"> {{ 'INVENTORY_SINGLE_VIEW.BTN_EDIT' | translate }}
              </button>
            }
            @if (allowInvalidateInventory) {
              <button data-testid="inventory-invalidate-btn" [disabled]="inventoryData.isInvalid" class="btn primary-btn inventory-action-btn"
                (click)="invalidateInventory()"> {{ 'INVENTORY_SINGLE_VIEW.BTN_INVALIDATE' | translate }}
              </button>
            }

            @if (delete) {
              <button data-testid="inventory-delete-btn" class="btn red-btn inventory-action-btn"(click)="showDeleteDialog()">
                {{ 'INVENTORIES.BTN_DELETE' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid='inventory-details'>{{ 'INVENTORY_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  @if (brandsTotalRecords > 1 && !hasOnlyOneActiveBrand) {
                    <dt data-testid="inventory-brand-label" class="label grid-cols-1 pt-3">
                      {{ 'INVENTORY_SINGLE_VIEW.BRAND' | translate }}
                    </dt>
                    <dd data-testid="inventory-brand" class="value pt-3 pb-3">
                      {{ inventoryData.brandName | defaultValue }}
                    </dd>
                  }

                  <dt data-testid='inventory-retailer-label' class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.RETAILER' | translate }}</dt>
                  <dd data-testid='inventory-retailer' class="value pt-3 pb-3">
                    @if (inventoryData.retailerId && allowViewRetailer) {
                      <a [routerLink]="['/retailers/', inventoryData.retailerId]" class="inline-flex items-center link">
                        {{ inventoryData.retailerName }}
                      </a>
                    } @else {
                      {{ inventoryData.retailerName }}
                    }
                  </dd>

                  <dt data-testid='inventory-islast-label' class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.IS_LAST' | translate }}</dt>
                  <dd data-testid='inventory-islast' class="value pt-3 pb-3">{{ inventoryData.isLast | friendlyBoolean | defaultValue }}</dd>

                  <dt data-testid='inventory-comment-label' class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.INVENTORY_COMMENTS' | translate }}</dt>
                  <dd data-testid='inventory-comment' class="value pt-3 pb-3">{{ inventoryData.comment | defaultValue }}</dd>

                  <dt data-testid='inventory-updatedon-label' class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.UPDATED_ON' | translate }}</dt>
                  <dd data-testid='inventory-updatedon' class="value pt-3 pb-3">{{ inventoryData.updatedOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                  </dd>

                  <dt data-testid='inventory-updatedby-label' class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.UPDATED_BY' | translate }}</dt>
                  <dd data-testid='inventory-updatedby' class="value pt-3 pb-3">
                    @if (inventoryData.updatedById && allowViewUser) {
                      <a [routerLink]="['/users/', inventoryData.updatedById]" class="inline-flex items-center link">
                        {{ inventoryData.updatedByFullName | defaultValue }}
                      </a>
                    } @else {
                      {{ inventoryData.updatedByFullName | defaultValue }}
                    }
                  </dd>
                  @if (inventoryData.isInvalid) {
                      <dt data-testid="inventory-invalidationReason-label" class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.INVALIDATE_REASON' | translate }}</dt>
                      <dd data-testid="inventory-invalidationReason" class="value pt-3 pb-3">{{ inventoryData.invalidationReason | defaultValue }}</dd>
                    }
                </dl>
              </div>
            </section>
            @if (inventoryData.inventoryItems) {
              <section class="row">
                <div class="col-12 mb-3">
                  <h4 data-testid='inventory-items'>
                    {{ 'INVENTORY_SINGLE_VIEW.ITEMS_IN_INVENTORY' | translate }}
                    ({{ inventoryData.totalItems }})
                  </h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                </div>
                <div class="col-12">
                  <p-table [value]="paginatedItems">
                    <ng-template #header>
                      <tr>
                        <th>
                          <div class="header-wr">
                            <span data-testid="table-header-0" class="col-name">{{ 'INVENTORY_SINGLE_VIEW.TH_PRODUCT_NAME' | translate }}</span>
                          </div>
                        </th>
                        <th>
                          <div class="header-wr">
                            <span data-testid="table-header-1" class="col-name">{{ 'INVENTORY_SINGLE_VIEW.TH_SERIAL_NUMBER' | translate }}</span>
                          </div>
                        </th>
                        @if (companyHasCpo) {
                          <th>
                            <div class="header-wr">
                              <span data-testid="table-header-2" class="col-name">
                                {{ 'INVENTORY_SINGLE_VIEW.TH_IS_CPO' | translate }}
                              </span>
                            </div>
                          </th>
                        }
                        <th>
                          <div class="header-wr">
                            <span data-testid="table-header-4" class="col-name">{{ 'INVENTORY_SINGLE_VIEW.TH_STATUS' | translate }}</span>
                          </div>
                        </th>
                        <th>
                          <div class="header-wr">
                            <span data-testid="table-header-actions" class="col-name">{{ 'INVENTORY_SINGLE_VIEW.TH_ACTIONS' | translate }}</span>
                          </div>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-inventoryItem let-rowIndex="rowIndex">
                      <tr [attr.data-id]="inventoryItem.id">
                        <td>
                          <span class="p-column-title">{{ 'INVENTORY_SINGLE_VIEW.TH_PRODUCT_NAME' | translate }}:</span>
                          <span [attr.data-testid]="'cell-0-' + rowIndex"
                            pTooltip="{{ ('INVENTORY_SINGLE_VIEW.SKU' | translate) + ': ' + (inventoryItem.item?.product?.sku | defaultValue) }}"
                            tooltipPosition="top">{{ inventoryItem.productName | defaultValue }}</span>
                        </td>
                        <td>
                          <span class="p-column-title">{{ 'INVENTORY_SINGLE_VIEW.TH_SERIAL_NUMBER' | translate }}:</span>
                          @if (inventoryItem.hasBlockchain) {
                            <span class="icon-only icon-block-chain" pTooltip="{{ 'INVENTORY_SINGLE_VIEW.STORED_IN_BLOCKCHAIN' | translate }}" tooltipPosition="top">
                            </span>
                          }
                          <span [attr.data-testid]="'cell-1-' + rowIndex">{{ inventoryItem.serialNumber | defaultValue }}</span>
                          @if (companyHasCpo) {
                            <td>
                              <span class="p-column-title">
                                {{ 'INVENTORY_SINGLE_VIEW.TH_IS_CPO' | translate }}:
                              </span>
                              <span [attr.data-testid]="'cell-2-' + rowIndex">
                                {{ inventoryItem.isCpo | friendlyBoolean }}
                              </span>
                            </td>
                          }
                        <td>
                          <span class="p-column-title">{{ 'INVENTORY_SINGLE_VIEW.TH_STATUS' | translate }}:</span>
                          <span [attr.data-testid]="'cell-4-' + rowIndex" class="tag" [ngClass]="{
                              'tag-green': inventoryItem.state === inventoryItemState.INVENTORY_ITEM_EXISTS,
                              'tag-red': inventoryItem.state === inventoryItemState.INVENTORY_ITEM_DOES_NOT_EXIST,
                              'tag-orange': inventoryItem.state === inventoryItemState.INVENTORY_ITEM_IS_NOT_VALID,
                              'tag-blue': inventoryItem.state === inventoryItemState.INVENTORY_ITEM_REVIEW,
                              'tag-gray': inventoryItem.state === inventoryItemState.INVENTORY_ITEM_STOLEN,
                              'tag-yellow': inventoryItem.state === inventoryItemState.INVENTORY_ITEM_SOLD
                            }">{{ inventoryItem.state | inventoryItemState }}</span>
                        </td>
                        <td class="actions-col">
                          <div class="actions gap-2">
                            @if (allowModifyInventory){
                              @if (inventoryItem.state === inventoryItemState.INVENTORY_ITEM_REVIEW) {
                                <button data-testid="inventory-item-view-detail-btn" type="button"
                                  pTooltip="{{ 'INVENTORIES.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye" (click)="viewInventoryItemDetails($event, inventoryItem.serialNumber, inventoryItem.id)" [attr.data-testid]="'btn-view-' + rowIndex">
                                  <span class="btn-label">
                                    {{ 'INVENTORIES.VIEW_INVENTORY_ITEM_DETAILS' | translate }}
                                  </span>
                                </button>
                              }

                              <button type="button" pTooltip="{{ 'INVENTORY_SINGLE_VIEW.REMOVE_ITEM' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-remove" (click)="onRemoveItemFromInventory($event, inventoryItem.id)" [attr.data-testid]="'btn-remove-' + rowIndex">
                                <span class="btn-label">
                                  {{ 'INVENTORY_SINGLE_VIEW.REMOVE_ITEM' | translate }}
                                </span>
                              </button>
                            }
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                      <tr>
                        <td colspan="6">{{ 'INVENTORY_SINGLE_VIEW.NO_DATA' | translate }}</td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <!-- Pagination -->
                  <app-custom-paginator
                    data-testid="paginator"
                    [pageNumber]="paginatorPageNumber"
                    [rows]="paginatorRows"
                    [totalRecords]="totalRecords"
                    [rowsPerPageOptions]="[10, 20, 30]"
                    [showCurrentPageReport]="true"
                    [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                    [disabled]="!totalRecords"
                    [alwaysShow]="true"
                    [tableName]="'Inventory'"
                    [showFirstLastIcon]="true"
                    [showPageLinks]="true"
                    [showPageSizeSelector]="true"
                    (onPageChange)="onPageChange($event)">
                  </app-custom-paginator>

                </div>
              </section>
            }
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modalbox: add item to inventory -->
<p-dialog
  [(visible)]="displayAddItemsModalbox"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  appendTo="body"
  [contentStyle]="{ height: '50vh', minHeight: '400px', padding: '0' }"
  styleClass="inventory-scanner-dialog"
  (onShow)="onScannerDialogShow()"
  (onHide)="onScannerDialogHide()">

  <ng-template #header>
    <div class="flex items-center justify-between w-full">
      <span class="p-dialog-title">
        {{ 'MODALBOXES.TITLE_ADD_INVENTORY_ITEMS' | translate }}
      </span>
    </div>
  </ng-template>

  @if (scannerMounted) {
    <app-multi-scanner
      #multiScanner
      [title]="'MODALBOXES.TITLE_ADD_INVENTORY_ITEMS' | translate"
      [autoStart]="true"
      [initialItems]="scannerInitialItems"
      [allowDuplicateScans]="false"
      [showCameraSelector]="true"
      [startDrawerOpen]="false"
      [openDrawerOnScan]="false"
      captureTemplateName="ReadSingleBarcode"
      (itemsChange)="onScannerItemsChange($event)"
      (finishScanning)="onScannerFinish($event)"
      (scannerClosed)="requestScannerModalClose()"
      (scannerError)="onScannerError($event)">
    </app-multi-scanner>
  }
</p-dialog>

<!-- Modalbox: prompt confirm leaving without finish scanning -->
<p-dialog [(visible)]="displayUnsavedScannerItemsModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="false" appendTo="body">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_UNSAVED_SCANNER_ITEMS' | translate }}</span>
  </ng-template>
  <p data-testid="unsaved-scanner-items-message" class="text-base">{{ 'MODALBOXES.DESCRIPTION_UNSAVED_SCANNER_ITEMS_AFTER_CLOSE' | translate }}</p>
  <ng-template #footer>
    <button data-testid="unsaved-scanner-items-dismiss-btn" type="button" class="btn outline-btn" (click)="dismissUnsavedScannerItems()">
      {{ 'MODALBOXES.BTN_DISCARD_SCANNER_ITEMS' | translate }}
    </button>
    <button data-testid="unsaved-scanner-items-save-btn" type="button" class="btn primary-btn" (click)="saveUnsavedScannerItems()">
      {{ 'MODALBOXES.BTN_SAVE_SCANNER_ITEMS' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Modalbox: inventory item removal -->
<p-dialog [header]="'MODALBOXES.TITLE_REMOVE_ITEM_FROM_INVENTORY' | translate"
  [(visible)]="displayRemoveItemConfirmationModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <p data-testid="item-remove-text" class="text-base" [innerHTML]="'MODALBOXES.DESCRIPTION_REMOVE_ITEM_FROM_INVENTORY' | translate"></p>
  <ng-template #footer>
    <button data-testid="item-remove-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelItemRemoval()">{{
      'MODALBOXES.BTN_CANCEL_REMOVE_INVENTORY_ITEM' |
      translate }}</button>
    <button data-testid="item-remove-submit-btn" type="button" class="btn primary-btn" (click)="onConfirmItemRemoval()">{{
      'MODALBOXES.BTN_REMOVE_INVENTORY_ITEM' | translate }}</button>
  </ng-template>
</p-dialog>

<!-- Modalbox: inventory item review-->
 <p-dialog [header]="'MODALBOXES.TITLE_REVIEW_INVENTORY_ITEM_DETAILS' | translate"
  [(visible)]="displayInventoryItemDetailsModalbox" [modal]="true" [blockScroll]="true"[draggable]="false" [resizable]="false">
  <p class="text-base" [innerHTML]="'MODALBOXES.DESCRIPTION_REVIEW_ITEM' | translate"></p>

  @if (inMemoryPagedResults.length) {
    <section class="row pb-6">
      <!-- Product results -->
      <ul id="product-results" class="mb-2">
        @for (item of inMemoryPagedResults; track item; let last = $last; let count = $count) {
          <li class="product-item row mt-3 mb-3" [attr.product-id]="item.product?.id" [ngClass]="{ 'border-b pb-6': count > 1 && !last }">

            <div class="col-12 col-sm-12 col-md-4 col-lg-3">
              <img [src]="item._customisation?.imageUrl || item.product?.imageUrl || item.product?.productType?.imageUrl" class="w-100 mt-2 featured-image"/>
            </div>

            <!-- DETAILS -->
            <div class="col-12 col-sm-12 col-md-8 col-lg-9">
              <dl class="details-grid">
                <dt data-testid="review-product-name-label" class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.PRODUCT_NAME' | translate }}</dt>
                <dd data-testid="review-product-name" class="value pt-3 pb-3">{{ item.product?.name }}</dd>

                <dt data-testid="review-product-serialnumber-label" class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.SERIAL_NUMBER' | translate }}</dt>
                <dd data-testid="review-product-serialnumber" class="value pt-3 pb-3">{{ item.serialNumber }}</dd>

                <dt data-testid="review-product-sku-label" class="label grid-cols-1 pt-3">{{ 'INVENTORY_SINGLE_VIEW.REFERENCE' | translate }}</dt>
                <dd data-testid="review-product-sku" class="value pt-3 pb-3">{{ item.product?.sku | defaultValue }}</dd>
              </dl>

              <div class="row mt-3">
                <div class="col-4">
                  <button data-testid="review-select-btn" class="btn outline-btn w-full" (click)="onSelectItem(item.id)">
                    {{ 'INVENTORY_SINGLE_VIEW.SELECT_PRODUCT' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>

      @if (inMemoryTotalRecords > inMemoryPaginator.rows) {
        <p-paginator
          data-testid="paginator"
          [first]="inMemoryPaginator.first"
          [rows]="inMemoryPaginator.rows"
          [totalRecords]="inMemoryTotalRecords"
          (onPageChange)="onInMemoryPageChange($event)">
        </p-paginator>
      }
      <!-- /Product results -->
    </section>
  }
</p-dialog>

<!-- Modalbox: invalidate inventory -->
<p-dialog [header]="'MODALBOXES.TITLE_INVALIDATE_INVENTORY' | translate" [(visible)]="displayInvalidateInventoryModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="false" class="compact-modal">
  <form [formGroup]="invalidateInventoryForm" (ngSubmit)="onSubmitInvalidateInventoryForm()" class="mt-0">
    <div class="field-wr flex flex-col col-12">
      <label data-testid="invalidate-inventory-reason-label" class="block text-sm" for="reason">{{ 'INVENTORY_SINGLE_VIEW.INVALIDATE_REASON' | translate }}<i
          class="icon-required-field"></i></label>
      <input data-testid="invalidate-inventory-reason"  type="text" formControlName="reason" autocomplete="off">
      @if (
        invalidateInventoryForm.get('reason')?.invalid &&
        (invalidateInventoryForm.get('reason')?.dirty || invalidateInventoryForm.get('reason')?.touched)
      ){
          @if (invalidateInventoryForm.get('reason')?.hasError('required')) {
            <small data-testid="reason-mandatory" class="p-error">
              {{ 'FORMS.MANDATORY_FIELD' | translate }}
            </small>
          }

          @if (invalidateInventoryForm.get('reason')?.hasError('maxlength')) {
            <small data-testid="reason-length-error" class="p-error">
              {{ 'FORMS.FIELD_LENGTH_EXCEEDED' | translate }}
            </small>
          }
      }
    </div>
  </form>

  <ng-template #footer>
    <button data-testid="cancel-shipment-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelInvalidateInventoryForm()">
      {{ 'MODALBOXES.BTN_CANCEL_INVALIDATE_INVENTORY' | translate }}
    </button>
    <button data-testid="cancel-shipment-submit-btn" type="submit" class="btn primary-btn" [disabled]="invalidateInventoryForm.invalid"
      (click)="onSubmitInvalidateInventoryForm()">
      {{ 'MODALBOXES.BTN_CONFIRM_INVALIDATE_INVENTORY' | translate }}
    </button>
  </ng-template>
</p-dialog>
<!-- Delete inventory -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_INVENTORY'" (onClose)="deleteInventory()"></dialog-reason>
